export const URL_WHYDOXPRO = "/#whydoxpro"
export const URL_FEATURES = "/#features"
export const URL_SERVICES = "/#services"
export const URL_HOW_IT_WORKS = "/#how-it-works"
